import React, { ReactNode, useContext } from 'react';
import { Popover } from 'antd';

import UserProfileContext from '@totem/components/userContext/UserProfileContext';

type Props = {
  content?: ReactNode;
  children?: ReactNode;
};

const IBTooltip = ({ content, children }: Props) => {
  const { showTooltips } = useContext(UserProfileContext);

  if (!showTooltips) {
    return <>{children}</>;
  }

  return (
    <Popover content={content} trigger="hover">
      {children}
    </Popover>
  );
};

export default IBTooltip;
